// extracted by mini-css-extract-plugin
export default {"formItem":"add_formItem__WJbaw","footerActions":"add_footerActions__+ZL2s"};